import {of as observableOf,  Observable } from 'rxjs';
import {catchError} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/legacy/response';
import { IProducts } from './product-model';
@Injectable({ providedIn: 'root' })
export class ProductsService {
    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.dashboardApi.baseUrl}${environment.dashboardApi.prefix}${ProductsService.ENDPOINT}`; }
    private static readonly ENDPOINT = 'products';

    public getProducts(): Observable<SuccessResponse<IProducts> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<IProducts>>(ProductsService.URL).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }
}
